import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MbNavigationService, NavigationNode } from '../../mb-navigation.service'
import { BehaviorSubject, combineLatest } from 'rxjs'
import { NavigationCategoryClickEvent } from '../../../components/types'
import { map } from 'rxjs/operators'
import { CmsLinkType } from '../../../enums/cms-link-type'

@Component({
  selector: 'mb-category-navigation-categories',
  templateUrl: './mb-category-navigation-categories.component.html',
  styleUrls: ['./mb-category-navigation-categories.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MbCategoryNavigationCategoriesComponent {

  @Output() categoryClick = new EventEmitter<NavigationCategoryClickEvent>()

  @Input() set selectedCategory (category: NavigationNode | undefined | null) {
    this.selectedCategory$.next(category)
  }

  navigation$ = this.navigationService.navigation$
  selectedCategory$ = new BehaviorSubject<NavigationNode | undefined | null>(undefined)

  state$ = combineLatest([this.navigation$, this.selectedCategory$]).pipe(
    map(([navigation, selectedCategory]) => ({ navigation, selectedCategory } as MbCategoryNavigationCategoriesState)))

  constructor (private navigationService: MbNavigationService) {
  }

  protected readonly cmsLinkType = CmsLinkType
}

export interface MbCategoryNavigationCategoriesState {
  navigation: NavigationNode[];
  selectedCategory: NavigationNode | undefined | null;
}
